

export const INPUT_UPDATE = 'INPUT_UPDATE';